<template>
  <div class="row">
    <div class="flex xs12">
      <va-card title="服务标签">
        <div class="row">
          <div class="flex xs12">
            <div class="row">
              <div class="flex xs12">
                <va-chip class="mb-2" color="primary" :key="val.id" v-for="val in serviceTags">{{ val.name }}</va-chip>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="flex xs4">
            <va-input
              v-model="saveTag"
              label='新增标签'
              removable
              :error="!!savaTagError.length"
              :error-messages="savaTagError"
            />
          </div>
          <div class="flex xs2">
            <va-button icon="ion-ios-checkmark" @click="clickSaveTag">submit</va-button>
          </div>
          <div class="flex xs4">
            <va-input
              v-model="deleteTag"
              label='删除标签'
              removable
              :error="!!deleteTagError.length"
              :error-messages="deleteTagError"
            />
          </div>
          <div class="flex xs2">
            <va-button icon="ion-md-close ion" @click="clickDeleteTag">submit</va-button>
          </div>
        </div>
      </va-card>
    </div>
    <div class="flex xs12">
      <va-card title="在线课程实战列表">
        <div class="row align--center mb-1">
          <div class="flex xs12 sm6">
            <va-input
              class="ma-0"
              :value="actionName"
              placeholder="search by name"
              @input="search"
              removable
            >
              <va-icon name="fa fa-search" slot="prepend"/>
            </va-input>
          </div>
          <div class="flex xs12 sm6">
            <div class="d-flex justify--end">
              <va-button color="info" small :to="{ name: 'saveOnlineAction' }">新增在线项目实战</va-button>
            </div>
          </div>
        </div>
        <va-data-table
          :fields="fields"
          :data="filteredData"
          :loading="loading"
          :totalPages="totalPages"
          @page-selected="listOnlineAction"
          api-mode
        >
          <template slot="cover" slot-scope="props">
            <img :src="props.rowData.imageUrl" class="data-table-server-pagination---avatar" alt="avatar">
          </template>
          <template slot="sort" slot-scope="props">
            <va-input
              v-model="props.rowData.sortNum"
              type="number"
              :min="1"
            >
              <va-button slot="append" icon="ion-md-checkmark ion" color="info" small @click="updateSortNum(props.rowData)">
              </va-button>
            </va-input>
          </template>
          <template slot="actions" slot-scope="props">
            <va-button flat small color="gray" icon="fa fa-pencil"
              :to='{path:`updateOnlineAction/${props.rowData.id}`}'/>
            <va-button flat small color="gray" icon="fa fa-trash"
              @click="deleteModal = true;deleteId=props.rowData.id"/>
          </template>
        </va-data-table>

        <va-modal
          v-model="deleteModal"
          title="删除在线实战课程"
          okText="提交"
          position="center"
          message="请再次确认是否要删除？"
          @ok="confirmDelete"
        />

      </va-card>
    </div>
  </div>
</template>

<script>

import tagApi from '../../api/serviceTag'
import debounce from 'lodash/debounce'
import onlineActionApi from '../../api/onlineAction'

export default {
  data () {
    return {
      saveTag: '',
      deleteTag: '',
      serviceTags: [],
      savaTagError: [],
      deleteTagError: [],
      message: ['Required field'],
      onlineActions: [],
      actionName: '',
      loading: true,
      pageSize: 10,
      totalPages: 1,
      deleteModal: false,
      deleteId: null,
    }
  },
  computed: {
    fields () {
      return [
        {
          name: '__slot:cover',
          width: '60px',
        }, {
          name: 'name',
          title: '实战名称',
          width: '15%',
        },
        {
          name: '__slot:sort',
          title: '排序',
          width: '10%',
        },
        {
          name: 'intendedFor',
          title: '适用人群',
          width: '25%',
        },
        {
          name: 'projectDuration',
          title: '项目周期',
          width: '10%',
        }, {
          name: 'shortDescription',
          title: '简短描述',
          width: '30%',
        },
        {
          name: '__slot:actions',
          width: '10%',
          dataClass: 'text-left',
        },
      ]
    },
    computedTags () {
      return this.serviceTags.map(x => {
        return x.name
      })
    },
    filteredData () {
      if (!this.actionName || this.actionName.length < 1) {
        return this.onlineActions
      }
      return this.onlineActions.filter(item => {
        return item.name.toLowerCase().startsWith(this.actionName.toLowerCase())
      })
    },
  },
  created () {
    this.listTag()
    this.listOnlineAction()
  },
  methods: {
    listOnlineAction (pageNumber = 1) {
      this.loading = true
      const params = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
      }
      onlineActionApi.listOnlineAction(params)
        .then(response => {
          this.onlineActions = response.onlineActions
          this.totalPages = response.totalPage
          this.loading = false
        })
    },
    listTag () {
      tagApi.listTag().then(response => {
        console.log(response)
        this.serviceTags = response.tags
      }).catch(error => {
        console.log(error)
      })
    },
    clickSaveTag () {
      this.savaTagError = this.saveTag.length === 0 ? ['required field'] : []
      if (this.saveTag.length === 0) {
        return
      }
      const data = {
        name: this.saveTag,
      }
      tagApi.saveTag(data).then(response => {
        console.log(response)
        this.listTag()
      }).catch(error => {
        console.log(error)
      })
    },
    clickDeleteTag () {
      this.deleteTagError = this.deleteTag.length === 0 ? ['required field'] : []
      if (this.deleteTag.length === 0) {
        return
      }
      let tagId = 0
      this.serviceTags.forEach(x => {
        if (x.name === this.deleteTag) {
          tagId = x.id
        }
      })
      if (tagId === 0) {
        this.showToast('没有找到该标签', {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      }
      tagApi.deleteTag(tagId).then(response => {
        if (response.success === true) {
          this.listTag()
        }
      }).catch(error => {
        console.log(error)
      })
    },
    confirmDelete () {
      if (this.deleteId === null) return
      onlineActionApi.deleteOnlineAction(this.deleteId).then(response => {
        if (response.success === true) {
          this.listOnlineAction()
        }
      }).catch(error => alert(error.code))
    },
    search: debounce(function (actionName) {
      this.actionName = actionName
    }, 400),
    updateSortNum(params){
      const data = {
        id: params.id,
        name: params.name,
        imageUrl: params.imageUrl,
        shortDescription: params.shortDescription,
        intendedFor: params.intendedFor,
        projectDuration: params.projectDuration,
        learnedSkill: params.hasOwnProperty('learnedSkills') && params.learnedSkills.length !== 0 ? params.learnedSkills.join(',') : '',
        description: params.description,
        outline: params.outline,
        tagIds: params.tags.map(tag => {
          return tag.id
        }),
        teacherIds: params.teachers.map(teacher => {
          return teacher.id
        }),
        willReward: params.willReward,
        courses: params.courses,
        sortNum: params.sortNum,
      }
      onlineActionApi.updateOnlineAction(params.id, data).then(response => {
        if (response.success === true) {
          this.listOnlineAction()
        }
      }).catch(error => alert(error))
    }
  },
}

</script>
<style lang="scss">
.data-table-server-pagination---avatar {
  width: 60px;
  height: 60px;
  border-radius: 5%;
}
</style>
